
<template>
  <div class="lf marketing ml">
    <div class="marketing-wrap">
      <div class="sales_show">
        <p class="sales_show_title">今日销量：
        <ICountUp :delay="delay" :endVal="endVal"
            @ready="onReady" />
        <span class="is_up">19.21%</span>
        <img class="is_up_ico" src="@/assets/images/up_ico1.png" alt="">
        </p>
        <div class="statistic-box row">
            <div class="statistic-item col-md-6" v-for="item in indexData" v-bind:key="item.name">
                <div class="icon-content">
                    <span class="iconfont icon-shuju"></span>
                </div>
                <div class="text-content">
                    <div class="text">
                        <span class="counter">
                            <ICountUp :delay="delay" :endVal="item.value" :options="options"
                                @ready="onReady" />
                        </span>
                    </div>
                    <div class="sub-title">{{item.name}}</div>
                </div>
            </div>
        </div>
      </div>
      <div class="inner-wrap">
        <div class="nursing">
          <div class="nursing_item">
            排名
          </div>
          <div class="nursing_item">
            商户
          </div>
          <div class="nursing_item">
            年度总销量
          </div>
          <div class="nursing_item">
            月平均销量
          </div>
        </div>
        <el-carousel arrow="never" indicator-position="none" interval="4000" height="1.5rem" direction="vertical" :autoplay="true">
          <el-carousel-item v-for="item in 5" :key="item">
            <div class="nursing" v-for="(ite,idx) in 5">
              <div class="nursing_item">
                {{idx+1}}
              </div>
              <div class="nursing_item">
                官方旗舰店
              </div>
              <div class="nursing_item">
                {{idx*136}}
              </div>
              <div class="nursing_item">
                {{idx*16}}
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>

    </div>
    <title-h3 :titlemsg="titlemsg"></title-h3>
    <!-- <div class="marketing-wrap">
      <div class="marketing-inner">
         <div id="myChartPro" style="width:100%;height:100%;"></div>
      </div>
    </div> -->
  </div>

</template>

<script>
  import ICountUp from 'vue-countup-v2'
  import title from '../title';
  export default{
    name:'proChannel',
    data(){
      return{
        delay: 0,
        endVal: 120500,
        titlemsg:'最新订单',
        indexData: [{ name: '当月销售额', value: 2341560 }, { name: '对比上月增长', value: 1582 }, { name: '总订单数', value: 2320 }, { name: '客单价', value: 1560 }],
      }
    },
    mounted(){
      this.drawLine();
    },
    onReady(instance, CountUp){
      return
      const that = this
      instance.update(that.endVal + 100)
    },
    methods: {
      drawLine(){
        // 基于准备好的dom，初始化echarts实例
        let myChart = this.$echarts.init(document.getElementById('myChartPro'))
        // 绘制图表
        // 指定图表的配置项和数据
        var dataAxis = ['同程', '携程', '驴妈妈', '去哪儿网', '景区官网'];
        var data = [600, 990, 800, 450, 381];
        var yMax = 1000;
        var dataShadow = [];

        for (var i = 0; i < data.length; i++) {
          dataShadow.push(yMax);
        }

        var option =  {
          backgroundColor: 'transparent',
          grid:{
            left:'12%',
            top:'10%',
            bottom:'12%',
            right:'4%'
          },
          xAxis: {
            data: dataAxis,
            axisLabel: {
//              inside: true,
              textStyle: {
                color: '#fff'
              }
            },
            axisTick: {
              show: false
            },
            axisLine: {
              show: true,
              lineStyle:{
                color:'#637eaf'
              }
            },
            z: 10
          },
          yAxis: {
            type: 'value',
            splitLine:{show: false},//去除网格线
            axisLine: {
              show: true,
              lineStyle:{
                  color:'#637eaf'
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              textStyle: {
                color: '#fff'
              }
            }
          },
          series: [{
            data:data,
            type: 'bar',
            barWidth : 30,
            itemStyle:{
              color:'#ffd452'
            }
          }]};

        // 使用刚指定的配置项和数据显示图表。
        myChart.setOption(option);
      }
    },
    components:{
      'title-h3':title,
      ICountUp,
    }
  }

</script>

<style>
.inner-wrap{background-color: #100235;box-sizing: border-box;height: 1.8rem; width: 100%;border-radius: 4px;margin-top: 3%;overflow:hidden}
    .category-wraps{width: 49%;height:3.99rem;}
    .category-wraps .argument-warp{width: 96%}
    #myChart2{width: 50%; margin: 0 auto;height:3rem; padding-top:.215rem; overflow: hidden}
    #progress{width:40%; margin-left: 5%}
    .w326{width:32.6%}
    .nursing{
      color: #fff;
      display: flex;
    }
    .nursing_item{
      flex: 1;
      /* padding: 6px 0; */
      /* font-size: 14px; */
      /* border-left: 1px solid #1e6bb4; */
      text-align: center;
      height: 0.3rem;
      line-height: 0.3rem;
      font-size: 0.1rem;
      /* border-top: 1px solid #1e6bb4; */
    }
    .nursing_item:nth-child(5n){
      /* border-right: 1px solid #1e6bb4; */
    }
    .nursing:last-child{
      /* border-bottom: 1px solid #1e6bb4; */
    }
    /deep/.el-carousel__indicators{
      display: none;
    }
    .sales_show_title{
        color: #fff;
        height: 0.4rem;
        font-size: 0.28rem;
    }
    .sales_show_title .is_up{
      color: #0B8603;
      font-size: 0.25rem;
      font-weight: bold;
    }
    .sales_show_title .is_up_ico{
      width: 0.25rem;
      height: 0.25rem;
    }
    .statistic-box{
      display: flex;
      flex-wrap: wrap;
      width: 100%;
      margin-top: 0.05rem;
    }
    .statistic-item {
        display: flex;
        /* margin-bottom: 15px; */
        align-items: center;
        overflow: hidden;
        width: 50%;
        height: 0.7rem;
        color: #fff;
    }

    .statistic-item .icon-content {
        width: 0.55rem;
        min-width: 0.55rem;
        height: 0.55rem;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #3b4e82;
        border-radius: 50%;
    }
    .text-content .text{
      font-size: 0.3rem;
    }
    .text-content .sub-title{
        font-size: 0.16rem;
        color: #4e6bba;
    }
    .icon-content .iconfont {
        font-size: 24px;
        color: #fff;
    }

    .text-content {
        margin-left: 10px;
        overflow: hidden;
    }
</style>



// WEBPACK FOOTER //
// src/components/order/proChannel.vue